import { Loading } from '@/components/Loading';
import type React from 'react';
import styles from './index.module.scss';

export type ReflectionProps = {
  reflection: string | null | undefined;
  isSummarized: boolean;
  onOpenModal: () => void;
  overwriteBlockReason: string | null | undefined;
};

export const Reflection: React.FC<ReflectionProps> = ({
  reflection,
  isSummarized,
  onOpenModal,
  overwriteBlockReason,
}) => {
  return (
    <div>
      <div className={styles.mainContent}>
        <div className={styles.header}>
          <h3 className={styles.label}>あなたの振り返り</h3>
          {isSummarized && (
            <button
              type="button"
              onClick={onOpenModal}
              disabled={!!overwriteBlockReason}
            >
              振り返りを編集する
            </button>
          )}
        </div>
        {!isSummarized ? (
          <div className={styles.loadingContainer}>
            <Loading />
          </div>
        ) : (
          reflection && <p className={styles.reflectionText}>{reflection}</p>
        )}
      </div>
      {isSummarized && overwriteBlockReason && (
        <p className={styles.annotation}>{overwriteBlockReason}</p>
      )}
    </div>
  );
};
